import { render } from "./activityDivideManager.vue?vue&type=template&id=28275376&scoped=true"
import script from "./activityDivideManager.vue?vue&type=script&lang=js"
export * from "./activityDivideManager.vue?vue&type=script&lang=js"

import "./activityDivideManager.vue?vue&type=style&index=0&id=28275376&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28275376"]])

export default __exports__